import script from "./indexModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./indexModal.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__